import { generateHash } from '../../../utils/caching/common/key-generator';

export const generate3pHash: (userId: string, cloudId: string) => number = (
	userId: string,
	cloudId: string,
) => generateHash(`3p|${userId}|${cloudId}`);
